const DAILY_QUOTES = [
  "La paix intérieure commence lorsque vous choisissez de ne pas permettre à une autre personne ou événement de contrôler vos émotions.",
  "Respirez. Lâchez prise. Et rappelez-vous que ce moment est le seul dont vous êtes certain.",
  "Le calme est un super pouvoir. Cultivez-le chaque jour.",
  "Vous n'avez pas besoin de contrôler vos pensées. Vous avez juste besoin de ne pas les laisser vous contrôler.",
  "La méditation n'est pas une évasion, c'est une rencontre sereine avec la réalité.",
  "Chaque respiration est une nouvelle chance de tout recommencer.",
  "Le silence n'est pas vide, il est plein de réponses.",
  "Soyez comme l'eau : douce, fluide et pourtant assez forte pour sculpter la pierre.",
  "La plus grande découverte de ma génération est qu'un être humain peut changer sa vie en changeant ses attitudes.",
  "Ne laissez pas le bruit des opinions des autres étouffer votre voix intérieure.",
  "Le bonheur n'est pas quelque chose de prêt à l'emploi. Il vient de vos propres actions.",
  "Là où il y a de la volonté, il y a un chemin. Là où il y a du calme, il y a de la clarté.",
  "Votre corps est votre temple. Prenez-en soin avec amour et gratitude.",
  "L'anxiété ne vide pas le lendemain de ses peines, elle vide aujourd'hui de sa force.",
  "La vie est un écho. Ce que vous envoyez revient. Ce que vous semez, vous récoltez.",
  "Apprenez à être calme et vous serez toujours heureux.",
  "Le plus grand voyage commence par un simple pas... et une profonde respiration.",
  "Ce n'est pas la montagne que nous conquérons, mais nous-mêmes.",
  "La gratitude transforme ce que nous avons en suffisance.",
  "Prenez soin de votre corps. C'est le seul endroit où vous êtes obligé de vivre.",
  "Le moment présent est rempli de joie et de bonheur. Si vous êtes attentif, vous le verrez.",
  "Votre calme est votre force. Ne le donnez à personne.",
  "Chaque matin nous renaissons. Ce que nous faisons aujourd'hui est ce qui compte le plus.",
  "La douceur envers soi-même est la première étape vers la douceur envers les autres.",
  "Quand vous possédez la paix intérieure, vous pouvez être en paix avec tout le monde autour de vous.",
  "L'esprit est tout. Ce que vous pensez, vous le devenez.",
  "Inspirez le futur, expirez le passé.",
  "La seule façon de faire du bon travail est d'aimer ce que vous faites.",
  "N'attendez pas que la tempête passe. Apprenez à danser sous la pluie.",
  "Votre seule limite est votre esprit."
];

export const getDailyQuote = () => {
  const today = new Date();
  const dayOfYear = Math.floor((today - new Date(today.getFullYear(), 0, 0)) / 86400000);
  return DAILY_QUOTES[dayOfYear % DAILY_QUOTES.length];
};

export default DAILY_QUOTES;
